// @flow
import React from 'react';

type FieldProps = {
  showHelpText: boolean,
  helpText: any,
  className: string,
  children: any,
  noPlaceholders?: boolean
}

class FormFieldWrapper extends React.Component {
  props: FieldProps

  render() {
    return (
      <div className={`field ${this.props.className}`}>
        {!this.props.noPlaceholders && <div className='is-placeholder' />}
        {/* this extra className for horizontal radio buttons only */}
        <div className={`${this.props.className}`}>
          {this.props.children}
        </div>
        {this.props.helpText && this.props.showHelpText ? (
          <div className='field-help-text is-left'>
            {this.props.helpText}
          </div>
        ) : (<div
          className={`${this.props.noPlaceholders ? '' : 'is-placeholder'}`}
             />)}
      </div>
    );
  }
}

export default FormFieldWrapper;



// WEBPACK FOOTER //
// ./src/components/shared/FormFieldWrapper.js